export const regionsForSelect = (regions) => regions.map((region) => ({ value: region.id, label: region.attributes.name }));

export { regionsForSelect as default };
